// extracted by mini-css-extract-plugin
export default {"root":"athlete-card-gradient_root__Y3yA4"};